<div class="dialog-container">
    <div class="header">
        <!-- icon -->
        <div class="header-icon-container">
            <mat-icon class="header-icon">
                warning
            </mat-icon>
        </div>
        <div class="header-text">
            Escalate
        </div>
        <div class="icon-container">
            <button mat-icon-button mat-dialog-close class="header-icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="dialog-body">
        <div class="body-form">
        <mat-form-field class="input-style">
            <mat-label class="input-label">Escalation Reason</mat-label>
            <mat-select  [(ngModel)]="selectedReason"> 
                <mat-option *ngFor="let reason of reasons" [value]="reason">{{reason}}</mat-option>
            </mat-select>
        </mat-form-field>
        </div>
    </div>
    <!-- footer  -->
    <div class="footer">
        <div class="footer-content">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-button (click)="applyChanges()" [disabled]="!selectedReason">Save</button>
        </div>
    </div>
</div>

